import { Component } from '@angular/core';
import { HeaderComponent } from '../../../../layout/header/header.component';
import { NavbarComponent } from '../../../../layout/navbar/navbar.component';
import { SidebarComponent } from '../../../../layout/sidebar/sidebar.component';
import { RoutelinksService } from '../../../../services/core/routelinks.service';

@Component({
  selector: 'app-sendtaxes',
  standalone: true,
  imports: [HeaderComponent, NavbarComponent, SidebarComponent],
  templateUrl: './sendtaxes.component.html',
  styleUrl: './sendtaxes.component.css'
})
export class SendtaxesComponent {
  links: any[] = [];
  subLinks: any[] = [];

  constructor(private routelinks: RoutelinksService) { }

  ngOnInit(): void {
    this.links = this.routelinks.linksTaxes; // Inicializa la propiedad en ngOnInit
    this.subLinks = this.routelinks.subLinksTaxes; // Inicializa la propiedad en ngOnInit
  }
}
